module.exports = __webpack_public_path__ + "img/agriculture.f956ff9f.png";